export const version = '2.1.2-beta.1'
